import threadsService from '@/app-domains/threads/threads.service'
import BoxesService from '@/app-domains/boxes/boxes.service'
import activityService from '@/app-domains/activity/activity.service'
import messagesService from '../messages/messages.service'
import store from '@/core/store'
class FeedService {
  constructor () {
    this.intersectionCallback = this.intersectionCallback.bind(this)
    this.isReadObserverSetup = false
    this.isShowLessObserverSetup = false
    this.expandedMessages = []
  }

  handleFeedScroll (thresholdMultiplier) {
    const feedHeader = document.querySelector('.feed-header')
    const feedContent = document.querySelector('.feed-content')

    if (threadsService.isFilteringLoading()) return
    if (!feedHeader) return
      
    const { top } = feedHeader.getBoundingClientRect()
    // console.log(bottom, top, document.querySelector('.feed-content').scrollHeight)
    const positiveTop = -(top)
    // console.log(feedContent.scrollHeight * thresholdMultiplier - positiveTop)
    if (feedContent.scrollHeight * thresholdMultiplier - positiveTop < 0) {
      threadsService.applyCurrentFilterOnNextPage()
    } else if (document.body.getBoundingClientRect().top > -100) {
      // Pending to check here if there's a notification being shown.
      // NotificationsService.toggleNotificationVisibility(false)
    }
  }

  async getLastFeedRelatedEntities (onlyVisible) {
    await Promise.all([
      BoxesService.getUserBoxes(),
      activityService.getActivities(),
      threadsService.queryLastThreads({}, onlyVisible)
    ])
  }

  // TODO: Fix this
  handleVisibilityChange () {
    /* if (document.hidden) {
      message.dataset.lastViewStarted = 0
    } else {
      message.dataset.lastViewStarted = performance.now()
    } */
  }

  observeIfMessagesAreRead () {
    if (this.isReadObserverSetup) {
      this.messageObserver.disconnect()
      window.clearInterval(this.refreshIntervalID)
    }
    this.isReadObserverSetup = true
    this.visibleMessages = new Set()
    document.addEventListener('visibilitychange', this.handleVisibilityChange, false)
    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: [0, 0.75],
    }
    this.messageObserver = new window.IntersectionObserver(this.intersectionCallback, observerOptions)
    
    // Observe unread messages
    document.querySelectorAll('#main-feed-scroll div.ShowMoreHeight.unread.not_show_more').forEach(post => {
      this.messageObserver.observe(post)
    })

    // Observe unread responses
    document.querySelectorAll('#main-feed-scroll div.-rendered-response.not_needs_show_more').forEach(response => {
      this.messageObserver.observe(response)
    })
    this.refreshIntervalID = window.setInterval(() => this.handleRefreshInterval(), 300)
  }

  intersectionCallback (entries) {
    entries.forEach((entry) => {
      const message = entry.target
      // console.log('Dataset:', message.dataset)
      if (entry.isIntersecting) {
        // console.log('DEBUG: Intersection happening:', entry.intersectionRatio)
        if (entry.intersectionRatio >= 0.75) {
          message.dataset.lastViewStarted = entry.time
          this.visibleMessages.add(message)
        }
      } else {
        // console.log('DEBUG: Message out of viewport')
        this.visibleMessages.delete(message)
        // console.log('DEBUG:', this.visibleMessages)
      }
    })
  }

  handleRefreshInterval () {
    this.visibleMessages.forEach((visibleMessage) => {
      this.updateViewedMessageTimer(visibleMessage)
    })
  }

  updateViewedMessageTimer (message) {
    const lastVisibleStarted = message.dataset.lastViewStarted
    const currentTime = parseFloat(performance.now())
    if (lastVisibleStarted) {
      const diff = currentTime - lastVisibleStarted
      message.dataset.totalViewTime = parseFloat(message.dataset.totalViewTime || 0) + diff
    }
    if (message.dataset.totalViewTime >= 1800) {
      const messageId = message.getAttribute('_message')
      const threadId = message.getAttribute('_thread')
      const unread = message.getAttribute('_unread')
      // Avoid marking message as read twice, 'unread' is updated in the ShowMoreSection and Responses after marking
      if (unread === 'true') {
        // console.log(`DEBUG: MARKING AS READ --- ${messageId}`)
        const thread = threadsService.getThreadById(threadId)
        messagesService.markMessageAsRead(messageId, threadId, thread.boxId)
      }
      
      message.dataset.lastViewStarted = undefined
      message.dataset.totalViewTime = 0
      this.visibleMessages.delete(message)
    }
    message.dataset.lastViewStarted = parseFloat(currentTime)
  }

  setUpShowLessObserver () {
    if (this.isShowLessObserverSetup) {
      this.showLessObserver.disconnect()
    }
    this.isShowLessObserverSetup = true
    this.uncollapsedMessages = new Set()
    const observerOptions = {
    }
    this.showLessObserver = new window.IntersectionObserver(this.expandedMessagesCallback, observerOptions)
    this.updateShowLessObserver()
  }

  updateShowLessObserver (val) {
    if (!val) {
      // FIXME: How to know which expandedMessages have been shown? -- Handle also scroll up!
      /* this.expandedMessages.forEach((expandedMessage) => {
        // this.showLessObserver.unobserve(expandedMessage)
      }) */
    }
    document.querySelectorAll('#main-feed-scroll div.show_full').forEach(expandedMessage => {
      this.showLessObserver.observe(expandedMessage)
      this.expandedMessages.push(expandedMessage)
    })
  }

  expandedMessagesCallback (entries) {
    function isInViewport (element) {
      const rect = element.getBoundingClientRect()
      return (
        rect.top >= 0 &&
          rect.left >= 0 &&
          rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      )
    }
    entries.forEach((entry) => {
      const expandedMessage = entry.target
      const messageId = expandedMessage.getAttribute('_message')
      // console.log('Dataset:', message.dataset)
      if (entry.isIntersecting) {
        // console.log('DEBUG: Intersection happening:', entry.intersectionRatio)
        // TODO: Add condition here for checking if 'Show less' is visible with enough margin
        const showLess = document.querySelector(`div.show_full[_message="${messageId}"] .-show_more`)

        if (showLess && isInViewport(showLess)) {
          return store.commit(`MESSAGE_EXPANDED:${messageId}:FLOATING_READ_LESS_BUTTON`, false)
        }
        store.commit(`MESSAGE_EXPANDED:${messageId}:FLOATING_READ_LESS_BUTTON`, true)
      } else {
        store.commit(`MESSAGE_EXPANDED:${messageId}:FLOATING_READ_LESS_BUTTON`, false)
      }
    })
  }
}

export default new FeedService()
